import { motion } from "framer-motion";
import { WhatsAppIcon } from "@/components/WhatsAppIcon";

export default function WhatsAppFloat() {
  const number = (process.env.REACT_APP_WHATSAPP_NUMBER || "").replace(/\D/g, "");
  const message = encodeURIComponent("Hi Hunar Designs! I'm browsing your collection and have a question.");
  return (
    <motion.a
      href={`https://wa.me/${number}?text=${message}`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-button"
      aria-label="Chat with Hunar Designs on WhatsApp"
      initial={{ opacity: 0, scale: 0.6, y: 16 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ delay: 0.8, type: "spring", stiffness: 260, damping: 18 }}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.94 }}
      className="group fixed bottom-5 right-5 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_10px_30px_-6px_rgba(37,211,102,0.55)] transition-colors hover:bg-[#1fb857] sm:bottom-7 sm:right-7"
    >
      <span className="absolute inset-0 animate-ping rounded-full bg-[#25D366] opacity-25 [animation-duration:2.4s]" aria-hidden="true" />
      <WhatsAppIcon className="relative h-7 w-7" />
      <span className="pointer-events-none absolute right-full mr-3 hidden whitespace-nowrap rounded-full bg-obsidian px-3 py-1.5 text-xs font-semibold text-bone opacity-0 transition-opacity duration-200 group-hover:opacity-100 sm:block">
        Order on WhatsApp
      </span>
    </motion.a>
  );
}
